import React from "react";
import { Box, Grid2, Slider } from "@mui/material";

interface UCSliderProps {
  sliderPercent: number;
  onSliderChange: (percent: number) => void;
  disabled?: boolean;
}

const UCSlider: React.FC<UCSliderProps> = ({ sliderPercent, onSliderChange, disabled }) => {
  const handleSliderChange = (_: Event, value: number | number[]) => {
    const raw = Array.isArray(value) ? value[0] : value;
    onSliderChange(100 - raw);
  };

  return (
    <Grid2
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          position: "relative",
          aspectRatio: "3 / 7",
          height: "auto",
          maxHeight: "65vh",
          maxWidth: "100%",
          width: "100%",
          borderRadius: "10px",
          overflow: "hidden"
        }}
      >

        {/* Vehicle overlay */}
        <Box
          className="uc-selector"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundSize: "contain",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: 1,
          }}
        />

        {/* Slider */}
        <Slider
          orientation="vertical"
          value={100 - sliderPercent}
          onChange={handleSliderChange}
          min={0}
          max={100}
          step={0.5}
          disabled={disabled}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            zIndex: 2,
            color: "transparent",
            "& .MuiSlider-thumb": {
              height: "1px",
              width: "100%",
              backgroundColor: "#fff",
              border: "2px solid red",
            },
            "& .MuiSlider-rail, & .MuiSlider-track": {
              opacity: 0,
            },
          }}
        />
      </Box>
    </Grid2>
  );
};

export default UCSlider;
